import React from 'react';
import { Navigate } from 'react-router-dom';

const DashboardRedirect: React.FC = () => {
  // Check user's tier from localStorage (set during signup)
  const getUserTier = (): string => {
    const storedTier = localStorage.getItem('userTier');
    
    // Map 'medium' to 'professional' for consistency
    if (storedTier === 'medium' || storedTier === 'professional') {
      return 'professional';
    }
    
    if (storedTier && ['free', 'smb', 'enterprise'].includes(storedTier)) {
      return storedTier;
    }
    
    // Fallback: check if there's any tier indication in other storage
    const userEmail = localStorage.getItem('userEmail');
    if (userEmail) {
      // If user exists but no tier, default to free
      return 'free';
    }
    
    // No user data, redirect to free
    return 'free';
  };

  const userTier = getUserTier();
  console.log('🎯 DashboardRedirect: Redirecting to tier:', userTier);

  return <Navigate to={`/${userTier}/dashboard`} replace />;
};

export default DashboardRedirect;
